import ReactDOM from 'react-dom/client'
import App from './App'
import './globals.css'
import { KeycloakProvider } from './providers/KeycloakProvider'

/**
 * Note: StrictMode is disabled due to incompatibility with @react-keycloak/web
 * React 18's StrictMode causes components to mount twice in development,
 * which triggers Keycloak.init() twice and causes an error.
 * This is a known issue: https://github.com/react-keycloak/react-keycloak/issues/194
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <KeycloakProvider>
    <App />
  </KeycloakProvider>
)
